import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Toaster } from 'sileo';

export const Route = createRootRoute({
    component: () => (
        <>
            <div style={{ position: 'fixed', zIndex: 9999 }}>
                <Toaster
                    position="top-center"
                    options={{
                        fill: '#0d0d0d',
                        roundness: 12,
                        duration: 2000,
                        styles: {
                            title: 'text-white!',
                            description: 'text-white/75!',
                            badge: 'bg-white/10!',
                            button: 'bg-white/10! hover:bg-white/15!',
                        },
                    }}
                />
            </div>
            <Outlet />
        </>
    ),
});
